import React from 'react'

import { B2, BTN_SM, Button, SH1, Stack, XStack } from '@zet/design-system'
import { getLoginHash } from '@zet/utils/loginHash'

import { useNavigation } from '@hooks/useNavigation'

import EmptyCircle from '../../../../../assets/svgs/emptyCircle.svg'
import TickCircle from '../../../../../assets/svgs/tickCircle.svg'
import {
  STEP_DATA,
  STEP_MAP,
} from '../../../../constants/demoSaleApplication/constant'

const Steps = ({
  currentStep = 'APPLICATION_PROCESS',
}: {
  currentStep?: string
}) => {
  const { navigate } = useNavigation()

  const hash = getLoginHash()

  function getIcon(step: number) {
    if (step < STEP_MAP[currentStep]) {
      return <TickCircle />
    }
    return <EmptyCircle />
  }

  function getStyles(step: number) {
    if (step !== STEP_DATA.length) {
      if (step < STEP_MAP[currentStep]) {
        return 'border-l-2 border-success-50'
      } else {
        return 'border-grays-40 border-l-2 border-dashed'
      }
    }
    return ''
  }

  function handlePress(navigateTo: string) {
    navigate(navigateTo, { hash })
  }
  return (
    <Stack className="pt-6">
      {STEP_DATA.map((item) => (
        <Stack className="mb-1">
          <XStack className="ml-1">
            {getIcon(item.step)}
            <SH1 className="ml-4/2 text-grays-100">{item.h1}</SH1>
          </XStack>
          <Stack className={`mx-3 mt-1 pb-6 pl-4 ${getStyles(item.step)}`}>
            <B2 className="text-grays-70 -mt-1 text-start">{item.sh1}</B2>
            <Button
              onPress={() => handlePress(item.navigateTo)}
              disabled={item.step > STEP_MAP[currentStep]}
              className="bg-tertiary-100 mt-4/2 hover:bg-tertiary-150 self-start"
            >
              <BTN_SM className="text-white">{item.cta}</BTN_SM>
            </Button>
          </Stack>
        </Stack>
      ))}
    </Stack>
  )
}

export default Steps
